import Radio from "../common/radio";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Pagination from "../common/pagination";
import RptSummaryTable from "./rptSummaryTable";
import Piechart from "../charts/Piechart";
import { getAllIncidentTypes } from "../../services/incidentTypeService";
import { getIncidnetTypeSummaryRptData } from "../../services/reportsService";
import {
  populateMonthSelectors,
  populateStartAndEndDateBySelectedMonth
} from "../../utils/datetimeUtil.js";
import { paginate, sort } from "../../utils/datatableUtils";
import { generateReport } from "../../utils/pdfGenerator";
import { defaultTblPageSize } from "../../config.json";

class rptCategorySummary extends Component {
  state = {
    categorySummaryRptData: [],
    currentPage: 0,
    pageSize: defaultTblPageSize,
    searchQuery: "",
    selectedIncidentTypeId: 0,
    selectedMonthId: new Date().getMonth(),
    tableHeaders: ["Categories", "Community", "Incident Count"],
    sortColumn: { path: "incidentCount", order: "desc" }
  };

  async componentDidMount() {
    const allIncidentTypes = await this.populateIncidentTypes();
    const filterMonthsArr = populateMonthSelectors();
    const {
      selectedStartDate,
      selectedEndDate
    } = populateStartAndEndDateBySelectedMonth(
      this.state.selectedMonthId,
      filterMonthsArr
    );
    const categorySummaryRptData = await this.populateReportData(
      this.state.selectedIncidentTypeId,
      selectedStartDate,
      selectedEndDate
    );

    this.setState({
      allIncidentTypes,
      filterMonthsArr,
      categorySummaryRptData,
      selectedStartDate,
      selectedEndDate
    });
  }

  async populateIncidentTypes() {
    const { data } = await getAllIncidentTypes();
    return [{ id: 0, name: "All" }, ...data];
  }

  async populateReportData(
    selectedIncidentTypeId,
    selectedStartDate,
    selectedEndDate
  ) {
    const { data } = await getIncidnetTypeSummaryRptData(
      selectedIncidentTypeId,
      selectedStartDate,
      selectedEndDate
    );

    return data;
  }

  handlePageChange = event => {
    this.setState({ currentPage: event.page });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  handleCategoryChange = async ({ currentTarget: input }) => {
    const selectedIncidentTypeId = Number.parseInt(input.value);
    const categorySummaryRptData = await this.populateReportData(
      selectedIncidentTypeId,
      this.state.selectedStartDate,
      this.state.selectedEndDate
    );
    this.setState({
      categorySummaryRptData,
      selectedIncidentTypeId,
      currentPage: 0
    });
  };

  handleMonthChange = async ({ currentTarget: input }) => {
    const selectedMonthId = Number.parseInt(input.value);

    const {
      selectedStartDate,
      selectedEndDate
    } = populateStartAndEndDateBySelectedMonth(
      selectedMonthId,
      this.state.filterMonthsArr
    );

    const categorySummaryRptData = await this.populateReportData(
      this.state.selectedIncidentTypeId,
      selectedStartDate,
      selectedEndDate
    );

    this.setState({
      categorySummaryRptData,
      selectedMonthId,
      currentPage: 0
    });
  };

  handleExportClick = async () => {
    const {
      categorySummaryRptData,
      tableHeaders,
      selectedStartDate,
      selectedEndDate,
      sortColumn
    } = this.state;

    const dataSorted = sort(categorySummaryRptData, sortColumn);
    const exportData = [];

    for (let i = 0; i < categorySummaryRptData.length; i++) {
      let lst = [];
      lst.push(dataSorted[i].categoryName);
      lst.push(dataSorted[i].communityName);
      lst.push(dataSorted[i].incidentCount);
      exportData.push(lst);
    }

    generateReport(
      "Category Summary Report",
      `${selectedStartDate} - ${selectedEndDate}`,
      tableHeaders,
      exportData,
      ["auto", "*", "auto"]
    );
  };

  getPagedData = () => {
    const {
      categorySummaryRptData,
      pageSize,
      currentPage,
      sortColumn
    } = this.state;

    const dataSorted = sort(categorySummaryRptData, sortColumn);
    const dataPerPage = paginate(dataSorted, currentPage, pageSize);

    return { totalCount: categorySummaryRptData.length, data: dataPerPage };
  };

  render() {
    const {
      categorySummaryRptData,
      pageSize,
      currentPage,
      sortColumn,
      selectedIncidentTypeId,
      selectedMonthId
    } = this.state;

    const { totalCount, data } = this.getPagedData();
    const columns = [
      {
        path: "communityName",
        label: this.state.tableHeaders[1]
      },
      {
        path: "incidentCount",
        label: this.state.tableHeaders[2],
        content: summaryReportVO => (
          <Link
            to={`/rpt/incidents-details/${summaryReportVO.communityId}/${
              summaryReportVO.categoryId
            }/${selectedMonthId}`}
          >
            {summaryReportVO.incidentCount}
          </Link>
        )
      }
    ];

    if (selectedIncidentTypeId === 0) {
      columns.splice(0, 0, {
        path: "categoryName",
        label: this.state.tableHeaders[0]
      });
    }

    return (
      <React.Fragment>
        <div className="h2">
          <span className="fa fa-bar-chart mr-3" />
          Report - Incidents Summary by Category
        </div>
        <div className="row border" style={{ height: 230 }}>
          <div className="col-10 mt-3">
            <Radio
              name={"communityId"}
              value={this.state.selectedIncidentTypeId}
              label={"Category"}
              options={this.state.allIncidentTypes}
              onChange={this.handleCategoryChange}
            />
          </div>
          <div className="col mt-3">
            <Radio
              name={"id"}
              value={this.state.selectedMonthId}
              label={"Month"}
              options={this.state.filterMonthsArr}
              onChange={this.handleMonthChange}
            />
          </div>
        </div>
        <div className="row border mt-2">
          <div className="col-6 mt-3 mb-2">
            <RptSummaryTable
              id="tblCategorySummary"
              columns={columns}
              data={data}
              sortColumn={sortColumn}
              onLike={this.handleLike}
              onSort={this.handleSort}
            />
            <Pagination
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
              raiseExportClick={this.handleExportClick}
            />
          </div>
          <div className="col-6">
            <Piechart
              data={categorySummaryRptData}
              dataKey="incidentCount"
              nameKey="communityName"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default rptCategorySummary;
